import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import Select from 'react-select';

// Components
import Loader from '../../utils/Loader';

// CSS
import '../../../css/react-select.css';

// State
import { getLocations, getProvinces } from '../../../store/actions/locations';
import { createAccount } from '../../../store/actions/user';

class CreateForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.customer ? props.customer.id : null,
            fname: props.customer ? props.customer.fname : '',
            lname: props.customer ? props.customer.lname : '',
            email: props.customer ? props.customer.email : '',
            address: props.customer ? props.customer.address : '',
            address2: props.customer ? props.customer.address2 : '',
            city: props.customer ? props.customer.city : '',
            postal: props.customer ? props.customer.postal : '',
            country: props.customer ? props.customer.country : '',
            province: props.customer ? props.customer.province : '',
            phone: props.customer ? props.customer.phone : '',
        };
    }

    componentDidMount() {
        this.props.getLocations();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.default_country !== null && this.state.country === '') {
            this.setState({
                country: nextProps.default_country,
            });
        }
    }

    updateSelectedCountry = (country) => {
        this.setState(
            {
                country: country.id,
                province: '',
            },
            () => this.props.getProvinces(this.state.country)
        );
    };

    updateSelectedProvince = (province) => {
        this.setState({
            province: province.abbreviation,
        });
    };

    handleInputChange(event) {
        this.setState({
            [event.target.id]: event.target.value,
        });
    }

    handleKeyPress(event, item_id) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSubmit();
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.createAccount(this.state);
    }

    render() {
        const {
            isLoading,
            accountUpdateSuccess,
            customer = null,
            countries,
            provinces,
            errors,
            locationsError,
            locationsLoading,
        } = this.props;

        return (
            <div>
                {customer && <input type="hidden" name="id" value={customer.id} />}

                {accountUpdateSuccess && (
                    <div className="success msg_animate">
                        You have successfully updated your information!
                    </div>
                )}

                <div className="fieldset">
                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="fname">First Name:</label>

                            {errors.fname && (
                                <div className="error msg_animate">{errors.fname}</div>
                            )}
                            <input
                                type="text"
                                id="fname"
                                value={this.state.fname}
                                placeholder="First Name"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </div>

                        <div className="form-field no-label-field half-field">
                            <label htmlFor="lname">Last Name:</label>

                            {errors.lname && (
                                <div className="error msg_animate">{errors.lname}</div>
                            )}
                            <input
                                type="text"
                                id="lname"
                                value={this.state.lname}
                                placeholder="Last Name"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </div>
                    </div>

                    <div className="form-field no-label-field">
                        <label htmlFor="email">Email:</label>

                        {errors.email && (
                            <div className="error msg_animate">{errors.email}</div>
                        )}
                        <input
                            type="email"
                            id="email"
                            value={this.state.email}
                            placeholder="Email"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(e) => this.handleInputChange(e)}
                        />
                    </div>
                </div>

                <div className="fieldset">
                    <label className="title-label">Location Info</label>

                    <div className="form-field no-label-field">
                        <label htmlFor="password">Address:</label>

                        {errors.address && (
                            <div className="error msg_animate">{errors.address}</div>
                        )}
                        <input
                            type="text"
                            id="address"
                            value={this.state.address}
                            placeholder="Address"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(e) => this.handleInputChange(e)}
                        />
                    </div>
                    <div className="form-field no-label-field">
                        <label htmlFor="address2">Address 2:</label>

                        {errors.address2 && (
                            <div className="error msg_animate">{errors.address2}</div>
                        )}
                        <input
                            type="text"
                            id="address2"
                            value={this.state.address2}
                            placeholder="Address Line 2"
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            onChange={(e) => this.handleInputChange(e)}
                        />
                    </div>

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="city">City:</label>

                            {errors.city && (
                                <div className="error msg_animate">{errors.city}</div>
                            )}
                            <input
                                type="text"
                                id="city"
                                value={this.state.city}
                                placeholder="City"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </div>

                        <div className="form-field no-label-field half-field">
                            <label htmlFor="postal">Postal:</label>

                            {errors.postal && (
                                <div className="error msg_animate">{errors.postal}</div>
                            )}
                            <input
                                type="text"
                                id="postal"
                                value={this.state.postal}
                                placeholder="Postal"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </div>
                    </div>

                    <div className="floated-field-container">
                        {locationsError ? (
                            <div className="error top-margin">{locationsError}</div>
                        ) : locationsLoading ? (
                            <div className="pt2 pb2">
                                <Loader />
                            </div>
                        ) : (
                            <div className="floated-field-container">
                                <div className="form-field no-label-field half-field">
                                    <label htmlFor="country">Country:</label>

                                    {!!errors.country && (
                                        <div className="error">{errors.country}</div>
                                    )}

                                    <Select
                                        classNamePrefix="react-select"
                                        name={`country`}
                                        placeholder="Country"
                                        value={countries.filter(
                                            ({ id }) => id === this.state.country
                                        )}
                                        onChange={(selection) =>
                                            this.updateSelectedCountry(selection)
                                        }
                                        isClearable={false}
                                        getOptionLabel={({ title }) => title}
                                        getOptionValue={({ id }) => id}
                                        options={countries}
                                    />
                                </div>

                                <div className="form-field no-label-field half-field">
                                    <label htmlFor="province">Province:</label>

                                    {!!errors.province && (
                                        <div className="error">{errors.province}</div>
                                    )}

                                    <Select
                                        classNamePrefix="react-select"
                                        name={`province`}
                                        placeholder={
                                            this.state.country === 'CA'
                                                ? 'Province'
                                                : 'State'
                                        }
                                        value={provinces.filter(
                                            ({ abbreviation }) =>
                                                abbreviation === this.state.province
                                        )}
                                        onChange={(selection) =>
                                            this.updateSelectedProvince(selection)
                                        }
                                        isClearable={false}
                                        getOptionLabel={({ name }) => name}
                                        getOptionValue={({ abbreviation }) =>
                                            abbreviation
                                        }
                                        options={provinces}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="floated-field-container">
                        <div className="form-field no-label-field half-field">
                            <label htmlFor="phone">Phone:</label>

                            {errors.phone && (
                                <div className="error msg_animate">{errors.phone}</div>
                            )}
                            <NumberFormat
                                id="phone"
                                placeholder="Phone Number"
                                value={this.state.phone}
                                type="tel"
                                format="### ### ####"
                                mask="_"
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </div>
                    </div>
                </div>

                <div className="btn_container">
                    {errors.general && (
                        <div className="error msg_animate">{errors.general}</div>
                    )}

                    <button
                        className="btn submit-btn"
                        disabled={isLoading}
                        onClick={(e) => this.handleSubmit(e)}
                    >
                        <span>{customer ? 'Update' : 'Create'}</span>
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        shipping: state.checkout.shipping,
        countries: state.locations.countries,
        default_country: state.locations.default_country,
        provinces: state.locations.provinces,
        locationsLoading: state.locations.isLoading,
        locationsError: state.locations.error,
        errors: state.user.errors,
        isLoading: state.user.isLoading,
        accountUpdateSuccess: state.user.accountUpdateSuccess,
    };
};

export default connect(
    mapStateToProps,
    { getLocations, getProvinces, createAccount }
)(CreateForm);



// WEBPACK FOOTER //
// ./src/components/customer/create/CreateForm.js